import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmationToastComponent } from '../../../../components/confirmation-toast/confirmation-toast.component';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { ReportService } from 'src/app/services/report.service';
import { AuthMethodEnum } from 'src/app/models/enum/auth-method.enum';

@Component({
    selector: 'app-edit-funds',
    templateUrl: './edit-funds.component.html',
    styleUrl: './edit-funds.component.scss',
    standalone: false
})
export class EditFundsComponent implements OnInit {
  faExternalLink = faExternalLink;

  displayedColumns!: string[];
  spec: any;
  type: any;
  maxROAuth = 0;
  authorizedByList: any;
  authorizedByListWO: any;
  authorizationStatusList: any;

  // @ViewChild('forest') input?: ElementRef<HTMLInputElement>;

  specForm = this.formBuilder.group({
    ro_authorized_by_id: [null],
    wo_authorized_by_id: [null],
    fully_funded: [""],
    approved_unit_qty: [0],
    approved_unit_cost: [0],
    authorization_note: [""],
    authorization_status_id: [[null]],
    wo_approved_unit_qty: [0],
    wo_approved_unit_cost: [""],
    wo_fully_funded: [""],
  });

  constructor(
    public dialogRef: MatDialogRef<EditFundsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public readonly dialog: MatDialog,
    private readonly formBuilder: FormBuilder,
    public readonly toast: ConfirmationToastComponent,
    private readonly titleService: Title,
    private readonly sanitizer: DomSanitizer,
    private readonly reportService: ReportService,
  ) {
    this.titleService.setTitle("BAER - Edit Treatment Funds")
    dialogRef.disableClose = true;
    this.reportService.getAuthorizedByOptions().subscribe((options: any) => {
      this.authorizedByList = options.filter((option: any) => option.value != 3);
      this.authorizedByListWO = options.filter((option: any) => option.value == 3 || option.value == 4);
    });
    this.reportService.getSpecAuthorizedStatusOptions().subscribe((options: any) => {
      this.authorizationStatusList = options;
    });
  }


  ngOnInit(): void {
    this.spec = this.data.spec;
    this.type = this.data.type;

    if (this.spec.region == '08' || this.spec.region == '09' || this.spec.region == '10') this.maxROAuth = 100000;
    else this.maxROAuth = 500000;

    this.specForm.patchValue({
      ro_authorized_by_id: this.spec.ro_authorized_by_id,
      wo_authorized_by_id: this.spec.wo_authorized_by_id,
      fully_funded: this.spec.fully_funded,
      approved_unit_qty: this.spec.approved_unit_qty,
      approved_unit_cost: this.spec.approved_unit_cost,
      authorization_note: this.spec.authorization_note,
      authorization_status_id: this.spec.authorization_status_ids ?? [],
      wo_approved_unit_qty: this.spec.wo_approved_unit_qty,
      wo_approved_unit_cost: this.spec.wo_approved_unit_cost,
      wo_fully_funded: this.spec.wo_fully_funded,
    })

    this.specForm.controls.ro_authorized_by_id.valueChanges.subscribe((ro_auth_val: any) => {
      this.specForm.controls.approved_unit_qty.setValidators([Validators.required, Validators.max(this.spec.unit_qty)]);
      this.specForm.controls.approved_unit_qty.updateValueAndValidity();
      this.specForm.controls.approved_unit_cost.setValidators([Validators.required, this.maxAuthCheck()]);
      this.specForm.controls.approved_unit_cost.updateValueAndValidity();

      switch (ro_auth_val) {
        case AuthMethodEnum.RO_AUTHORIZED:
          if (this.specForm.value.fully_funded) {
            this.specForm.controls.approved_unit_qty.setValidators(null);
            this.specForm.controls.approved_unit_qty.updateValueAndValidity();
            this.specForm.controls.approved_unit_cost.setValidators(null);
            this.specForm.controls.approved_unit_cost.updateValueAndValidity();
          }
          this.specForm.controls.authorization_status_id.setValidators(null);
          this.specForm.controls.authorization_status_id.updateValueAndValidity();
          break;
        case AuthMethodEnum.FOWARD_TO_WO:
          this.specForm.controls.approved_unit_qty.setValidators(null);
          this.specForm.controls.approved_unit_qty.updateValueAndValidity();
          this.specForm.controls.approved_unit_cost.setValidators(null);
          this.specForm.controls.approved_unit_cost.updateValueAndValidity();
          this.specForm.controls.authorization_status_id.setValidators(null);
          this.specForm.controls.authorization_status_id.updateValueAndValidity();
          break;
        case AuthMethodEnum.SPLIT_AUTHORIZATION:
          this.specForm.controls.authorization_status_id.setValidators(null);
          this.specForm.controls.authorization_status_id.updateValueAndValidity();
          break;
        case AuthMethodEnum.NOT_AUTHORIZED:
          this.specForm.controls.approved_unit_qty.setValidators(null);
          this.specForm.controls.approved_unit_qty.updateValueAndValidity();
          this.specForm.controls.approved_unit_cost.setValidators(null);
          this.specForm.controls.approved_unit_cost.updateValueAndValidity();
          break;
      }
    })

    this.specForm.controls.fully_funded.valueChanges.subscribe((fully_funded: any) => {
      this.specForm.controls.approved_unit_qty.setValidators([Validators.required, Validators.max(this.spec.unit_qty)]);
      this.specForm.controls.approved_unit_qty.updateValueAndValidity();

      if (fully_funded) {
        this.specForm.controls.approved_unit_qty.setValidators(null);
        this.specForm.controls.approved_unit_qty.updateValueAndValidity();
        this.specForm.controls.approved_unit_cost.setValidators(null);
        this.specForm.controls.approved_unit_cost.updateValueAndValidity();
      }
    })

    this.specForm.controls.wo_authorized_by_id.valueChanges.subscribe((wo_auth_val: any) => {
      this.specForm.controls.wo_approved_unit_qty.setValidators([Validators.required, Validators.max(this.spec.unit_qty - (this.spec.approved_unit_qty ?? 0))]);
      this.specForm.controls.wo_approved_unit_qty.updateValueAndValidity();
      switch (wo_auth_val) {
        case AuthMethodEnum.WO_AUTHORIZED:
          if (this.specForm.value.fully_funded) {
            this.specForm.controls.wo_approved_unit_qty.setValidators(null);
            this.specForm.controls.wo_approved_unit_qty.updateValueAndValidity();
            this.specForm.controls.wo_approved_unit_cost.setValidators(null);
            this.specForm.controls.wo_approved_unit_cost.updateValueAndValidity();
          }
          this.specForm.controls.authorization_status_id.setValidators(null);
          this.specForm.controls.authorization_status_id.updateValueAndValidity();

          this.specForm.patchValue({ //set default amount for quicker form input
            wo_approved_unit_cost: (this.spec.approved_unit_cost ?? this.spec.unit_cost),
            wo_approved_unit_qty: (this.spec.unit_qty - (this.spec.approved_unit_qty ?? 0))
          })
          break;
        case AuthMethodEnum.NOT_AUTHORIZED:
          this.specForm.controls.wo_approved_unit_qty.setValidators(null);
          this.specForm.controls.wo_approved_unit_qty.updateValueAndValidity();
          this.specForm.controls.wo_approved_unit_cost.setValidators(null);
          this.specForm.controls.wo_approved_unit_cost.updateValueAndValidity();
          break;
      }
    })

    this.specForm.controls.wo_fully_funded.valueChanges.subscribe((wo_fully_funded: any) => {
      this.specForm.controls.wo_approved_unit_qty.setValidators([Validators.required, Validators.max(this.spec.unit_qty - (this.spec.approved_unit_qty ?? 0))]);
      this.specForm.controls.wo_approved_unit_qty.updateValueAndValidity();

      if (wo_fully_funded) {
        this.specForm.controls.wo_approved_unit_qty.setValidators(null);
        this.specForm.controls.wo_approved_unit_qty.updateValueAndValidity();
        this.specForm.controls.wo_approved_unit_cost.setValidators(null);
        this.specForm.controls.wo_approved_unit_cost.updateValueAndValidity();
      }
    })
  }
  maxAuthCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return (control.value * (this.specForm.value.approved_unit_qty ?? 0)) > this.maxROAuth ? { totalAboveLimit: true } : null;
    }
  }

  editFunds(): void {
    if (this.type == 'RO') this.editFundsRO();
    else this.editFundsWO();
  }

  editFundsRO() {
    let wo_approved_unit_cost: number | undefined = undefined
    let wo_approved_unit_qty: number | undefined = undefined
    switch (this.specForm.value.ro_authorized_by_id!) {
      case AuthMethodEnum.RO_AUTHORIZED:
        if (this.specForm.value.fully_funded) {
          this.specForm.patchValue({
            approved_unit_cost: this.spec.unit_cost,
            approved_unit_qty: this.spec.unit_qty
          })
        }
        wo_approved_unit_cost = 0
        wo_approved_unit_qty = 0
        this.specForm.patchValue({
          authorization_status_id: []
        })
        break;
      case AuthMethodEnum.FOWARD_TO_WO:
        this.specForm.patchValue({
          approved_unit_cost: null,
          approved_unit_qty: null,
          fully_funded: null,
          authorization_status_id: []
        })
        break;
      case AuthMethodEnum.SPLIT_AUTHORIZATION:
        this.specForm.patchValue({
          authorization_status_id: [],
          fully_funded: null,
        })
        break;
      case AuthMethodEnum.NOT_AUTHORIZED:
        this.specForm.patchValue({
          approved_unit_cost: null,
          approved_unit_qty: null,
          fully_funded: null,
        })
        wo_approved_unit_cost = 0
        wo_approved_unit_qty = 0
        break;
    }
    let data = {
      fully_funded: this.specForm.value.fully_funded,
      approved_unit_cost: this.specForm.value.approved_unit_cost,
      approved_unit_qty: this.specForm.value.approved_unit_qty,
      ro_authorized_by_id: this.specForm.value.ro_authorized_by_id,
      authorization_note: this.specForm.value.authorization_note,
      authorization_status_ids: this.specForm.value.authorization_status_id,

      // if status changes to RO authorized/not authorized, zero out any WO authorization
      wo_approved_unit_cost,
      wo_approved_unit_qty,
    }
    this.reportService.editSpec(data, this.spec.treatment_specification_id).subscribe({
      next: (response) => {
        this.toast.openSuccessSnackBar(`Treatment ${this.spec.treatment} has been updated.`);
        this.dialogRef.close(true);
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error updating ${this.spec.treatment}.`, "Please try editing the treatment record again.");
        this.dialogRef.close();
      },
    })
  }

  editFundsWO() {
    switch (this.specForm.value.wo_authorized_by_id!) {
      case AuthMethodEnum.WO_AUTHORIZED:
        if (this.specForm.value.wo_fully_funded) {
          this.specForm.patchValue({
            wo_approved_unit_cost: (this.spec.approved_unit_cost ?? this.spec.unit_cost),
            wo_approved_unit_qty: (this.spec.unit_qty - (this.spec.approved_unit_qty ?? 0))
          })
        }
        this.specForm.patchValue({
          authorization_status_id: []
        })
        break;
      case AuthMethodEnum.NOT_AUTHORIZED:
        this.specForm.patchValue({
          wo_approved_unit_cost: null,
          wo_approved_unit_qty: null,
          wo_fully_funded: null,
        })
        break;
    }
    let data = {
      wo_fully_funded: this.specForm.value.wo_fully_funded,
      wo_approved_unit_cost: this.specForm.value.wo_approved_unit_cost,
      wo_approved_unit_qty: this.specForm.value.wo_approved_unit_qty,
      wo_authorized_by_id: this.specForm.value.wo_authorized_by_id,
      authorization_note: this.specForm.value.authorization_note,
      authorization_status_ids: this.specForm.value.authorization_status_id,
    }
    this.reportService.editSpec(data, this.spec.treatment_specification_id).subscribe({
      next: (response) => {
        this.toast.openSuccessSnackBar(`Treatment ${this.spec.treatment} has been updated.`);
        this.dialogRef.close(true);
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error updating ${this.spec.treatment}.`, "Please try editing the treatment record again.");
        this.dialogRef.close();
      },
    })
  }

  unitTotal(cost: any, qty: any) {
    return cost * qty;
  }

  getAuthStatusText() {
    if (this.authorizationStatusList == null) return
    switch (this.specForm.value.authorization_status_id?.length) {
      case 0:
        return '';
      case 1:
        return this.authorizationStatusList[(this.specForm.value.authorization_status_id[0] ?? 0)].text;
      case 2:
        return this.authorizationStatusList[(this.specForm.value.authorization_status_id[0] ?? 0)].text + ' (+' + (this.specForm.value.authorization_status_id?.length - 1) + ' other)';
      default:
        return this.authorizationStatusList[(this.specForm.value.authorization_status_id![0] ?? 0)].text + ' (+' + (this.specForm.value.authorization_status_id?.length! - 1) + ' others)';
    }
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  decodeURI(url: string): string {
    let decoded = decodeURI(url)
    if (decoded.includes('http')) return decoded;
    else return 'https://' + decoded;
  }

  selectedAuthorized(event: any) {
    // 0 RO Authorized
    // 3 WO Authoirzed
    if (event.value == 0 || event.value == 2 || event.value == 3) {
      this.specForm.patchValue({
        approved_unit_qty: this.spec.unit_qty,
        approved_unit_cost: this.spec.unit_cost,
      })
    }
  }
}

// function maxAuthCheck(unit_qty: any): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     return (control.value * unit_qty) > 55 ? { totalAboveLimit: true } : null;
//   }
// }